// src/pages/Clients/clientsAPI.js
// Reuse your existing API functions from apiservice/hrpayroll
import {
  getClientApi,
  saveClientApi,
  deleteClientApi,
  getClientUserApi,
  saveClientUserApi,
  deleteClientUserApi,
  getEmailScheduleApi,
  saveClientPolicyApi,
  deleteClientPolicyApi,
  saveEmailScheduleApi,
} from "../../apiservice/hrpayroll";

export const api = {
  // Clients
  fetchClients: () => getClientApi(null),
  saveClient: (payload) => saveClientApi(payload),
  deleteClient: (payload) => deleteClientApi(payload),

  // Client Users
  fetchClientUsers: () => getClientUserApi(),
  saveClientUser: (payload) => saveClientUserApi(payload),
  deleteClientUser: (payload) => deleteClientUserApi(payload),

  // Email Schedule
  fetchEmailSchedules: () => getEmailScheduleApi(),
  saveEmailSchedule: (payload) => saveEmailScheduleApi(payload),

  // Leave Policy
  saveClientPolicy: (payload) => saveClientPolicyApi(payload),
  deleteClientPolicy: (payload) => deleteClientPolicyApi(payload),
};
